import { useParams } from 'react-router-dom'

import { Invitation } from '../components/invitations/Invitation'
import { SceneContainer } from '../components/scene/SceneContainer'

function InvitationScreen() {
  const { invitationId } = useParams()

  if (!invitationId) {
    return null
  }

  return (
    <SceneContainer>
      <Invitation invitationId={invitationId} />
    </SceneContainer>
  )
}

export default InvitationScreen
